import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getData } from '../utils/api';

const VersionContext = createContext(null);

export const useVersion = () => {
  const ctx = useContext(VersionContext);
  if (!ctx) {
    return {
      version: '1.0.0',
      buildNumber: '',
      lastUpdatedAt: null,
      releaseNotes: '',
      formattedDate: '',
      loading: false,
      refetch: () => {},
    };
  }
  return ctx;
};

const formatDateTime = (isoString) => {
  if (!isoString) return '';
  const date = new Date(isoString);
  return date.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'short',
  });
};

export const VersionProvider = ({ children }) => {
  const [versionData, setVersionData] = useState({
    version: '1.0.0',
    buildNumber: '',
    lastUpdatedAt: null,
    releaseNotes: '',
    formattedDate: '',
  });
  const [loading, setLoading] = useState(true);

  const fetchVersion = useCallback(async () => {
    try {
      const res = await getData('/app/version');
      if (res.success && res.data) {
        const data = res.data;
        setVersionData({
          version: data.version || '1.0.0',
          buildNumber: data.buildNumber || '',
          lastUpdatedAt: data.lastUpdatedAt || null,
          releaseNotes: data.releaseNotes || '',
          formattedDate: formatDateTime(data.lastUpdatedAt),
        });
      }
    } catch (_) {
      // silently keep defaults if API fails
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchVersion(); }, [fetchVersion]);

  return (
    <VersionContext.Provider value={{ ...versionData, loading, refetch: fetchVersion }}>
      {children}
    </VersionContext.Provider>
  );
};
